import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Toast/toastStore.ts
import { announce } from "../../../utils/announce.mjs";
var records = [];
var listeners = /* @__PURE__ */ new Set();
var nextId = 0;
function emit() {
  for (const listener of listeners) listener();
}
function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
function getToasts() {
  return records;
}
var MAX_OPEN = 5;
function show(type, message, options = {}) {
  const id = options.id ?? `toast-${++nextId}`;
  const existing = records.find((r) => r.id === id);
  const revision = !existing ? 0 : existing.type === "loading" && type !== "loading" ? existing.revision : existing.revision + 1;
  const record = { ...options, id, type, message, open: true, revision };
  records = existing ? records.map((r) => r.id === id ? record : r) : [...records, record];
  emit();
  if (existing?.type === "loading" && type !== "loading") announce([message, options.description].filter(Boolean).join(". "));
  const open = records.filter((r) => r.open);
  if (open.length > MAX_OPEN) {
    const oldest = open.find((r) => r.type !== "loading" && r.duration !== Infinity && r.id !== id);
    if (oldest) dismiss(oldest.id);
  }
  return id;
}
var EXIT_MS = 400;
var pendingPromises = /* @__PURE__ */ new Map();
function dismiss(id) {
  const closing = records.filter((r) => id === void 0 || r.id === id).map((r) => r.id);
  for (const closingId of closing) {
    const pending = pendingPromises.get(closingId);
    if (pending) pending.dismissed = true;
  }
  records = records.map((r) => closing.includes(r.id) ? { ...r, open: false } : r);
  emit();
  setTimeout(() => {
    records = records.filter((r) => !(closing.includes(r.id) && !r.open));
    emit();
  }, EXIT_MS);
}
function promise(work, messages, options = {}) {
  const id = show("loading", messages.loading, options);
  const pending = { dismissed: false };
  pendingPromises.set(id, pending);
  const settle = (type, message) => {
    if (pendingPromises.get(id) === pending) pendingPromises.delete(id);
    if (!pending.dismissed) show(type, message, { ...options, id });
  };
  work.then(
    (value) => settle("success", typeof messages.success === "function" ? messages.success(value) : messages.success),
    (error) => settle("error", typeof messages.error === "function" ? messages.error(error) : messages.error)
  );
  return work;
}
function isOpen(id) {
  return records.some((r) => r.id === id && r.open);
}
var toast = Object.assign(
  (message, options) => show("info", message, options),
  {
    success: (message, options) => show("success", message, options),
    warning: (message, options) => show("warning", message, options),
    error: (message, options) => show("error", message, options),
    loading: (message, options) => show("loading", message, options),
    promise,
    dismiss,
    /** Whether the toast with this id is showing: not yet dismissed, by the user or a timer. */
    isOpen
  }
);
export {
  dismiss,
  getToasts,
  subscribe,
  toast
};
//# sourceMappingURL=toastStore.mjs.map